export function formatAddress(raw) {
    try {
        const parsed = JSON.parse(raw);
        const addr = parsed.address;
        if (!addr) return null;
        const lines = [];
        if (addr.line1) lines.push(addr.line1);
        if (addr.line2) lines.push(addr.line2);
        const cityLine = [
            addr.city,
            addr.state,
            addr.postal_code
        ].filter(Boolean).join(', ');
        if (cityLine) lines.push(cityLine);
        if (addr.country) lines.push(addr.country);
        return {
            name: parsed.name ?? '',
            lines
        };
    } catch  {
        return null;
    }
}
